import _cloneDeep from 'lodash/cloneDeep';

const COMPONENT_NAME = 'uac-add-user';

export default class AddUserController {
    /** @ngInject */
    constructor(EventEmitter, ErrorsService) {
        this.eventEmitter = EventEmitter;
        this.ErrorsService = ErrorsService;
    }

    $onInit() {
        this.user = {
            first_name: '',
            last_name: '',
            middle_name: '',
            email: '',
            title: ''
        };

        this.genericErrors = this.ErrorsService.getGenericErrors();
        this.componentErrors = this.ErrorsService.getComponentErrors(COMPONENT_NAME);
    }

    create() {
        this.onCreate(this.eventEmitter({
            user: _cloneDeep(this.user)
        }));
    }

    cancel() {
        this.onCancel();
    }
}



// WEBPACK FOOTER //
// ./app/components/users-and-access/users/add-user/add-user.controller.js